import { render, staticRenderFns } from "./EditCarouselModal.vue?vue&type=template&id=5e08e1ca"
import script from "./EditCarouselModal.vue?vue&type=script&lang=js"
export * from "./EditCarouselModal.vue?vue&type=script&lang=js"
import style0 from "./EditCarouselModal.vue?vue&type=style&index=0&id=5e08e1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports